import React from "react";
import { useTranslation } from "react-i18next";
import { barHeights, changeOf } from "./zendeskFormat";
import styles from "./style.module.scss";

/** Week-over-week chip: ▲ red, ▼ green, "new" when there was nothing last week. */
export const ChangeChip = ({ changePct }) => {
  const { t } = useTranslation();
  const { dir, pct } = changeOf(changePct);
  if (dir === "new") return <span className={`${styles.chip} ${styles.new}`}>{t("zendeskPage.new")}</span>;
  return (
    <span className={`${styles.chip} ${styles[dir]}`}>
      {dir === "up" ? "▲ " : dir === "down" ? "▼ " : ""}
      {pct}%
    </span>
  );
};

export const DailyBars = ({ values, height = 110, compact = false }) => {
  const heights = barHeights(values);
  return (
    <div className={styles.bars} style={{ height }}>
      {heights.map((h, i) => (
        <div
          // Fixed 14-slot chart: the index is the day.
          // eslint-disable-next-line react/no-array-index-key
          key={i}
          className={i >= heights.length - 7 ? styles.cur : styles.prev}
          style={{ height: `${h}%`, borderRadius: compact ? "4px 4px 1px 1px" : undefined }}
          title={String(values[i])}
        />
      ))}
    </div>
  );
};
